import { cva, type VariantProps } from 'class-variance-authority'

export const buttonVariants = cva(
  'inline-flex items-center justify-center rounded-md font-sans font-medium tracking-[-0.005em] no-underline transition-[background-color,border-color,color,opacity] cursor-pointer disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        primary: 'bg-ink text-bg border border-ink hover:opacity-[0.87]',
        ghost: 'bg-surface text-ink border border-line hover:bg-surface-2',
        outline:
          'bg-transparent text-ink border border-line hover:border-line-2 hover:bg-surface-2',
        accent: 'bg-accent text-white border border-accent hover:opacity-90',
        link: 'text-accent underline-offset-2 hover:underline bg-transparent border-transparent',
      },
      size: {
        sm: 'h-8 px-3 text-xs',
        md: 'h-10 px-4 text-sm',
        lg: 'h-12 px-6 text-base',
        nav: 'h-auto px-[14px] py-[7px] text-[13px] font-semibold',
        cta: 'h-auto gap-2 px-6 py-[13px] text-[15px] font-semibold max-[768px]:px-5 max-[768px]:py-3 max-[768px]:text-sm',
        compact: 'h-auto px-[18px] py-2.5 text-sm font-semibold',
        touch: 'h-auto px-4 py-2.5 text-[13px] font-semibold',
        plan: 'h-auto w-full px-5 py-3 text-sm font-semibold',
        download: 'h-auto w-full justify-between gap-3 px-4 py-[11px] text-[13px] font-semibold',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  },
)

export type ButtonVariantProps = VariantProps<typeof buttonVariants>
